




import Vue from 'vue'
import Timeout = NodeJS.Timeout

interface Unicode {
  type: string,
  value: string,
}

export default Vue.extend({
  name: 'EmojiText',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data: () => ({
    fontsize: '10px',
    checkInterval: null as Timeout|null
  }),
  mounted (): void {
    this.updateFontSize()
    this.checkInterval = setInterval(() => this.updateFontSize(), 3000)
  },
  beforeDestroy (): void  {
    if (this.checkInterval !== null) clearInterval(this.checkInterval)
  },
  computed: {
    textHtml (): string {
      let html = ''
      const textlist: Unicode[] = this.splitsString(this.text)
      textlist.forEach((text) => {
        if (text.type === 'text') {
          html += text.value
        } else {
          html += `<img src="https://kiswe-data.s3.amazonaws.com/cloudcast/emojis/${text.value}.svg" height=${this.fontsize} >`
        }
      })
      return html
    }
  },
  methods: {
    updateFontSize (): void {
      const span: HTMLElement = this.$refs.span as HTMLElement
      this.fontsize = window.getComputedStyle(span)['font-size']
    },
    splitsString (text): Unicode[] {
      const list: Unicode[] = []
      let currentString = ''
      for (const char of text) {
        const unicode = this.toUni(char)
        const isEmoji = this.isEmoji(unicode)
        if (isEmoji && currentString !== '') {
          list.push({ type: 'text', value: currentString })
          currentString = ''
          list.push({ type: 'emoji', value: unicode })
        } else if (isEmoji) {
          list.push({ type: 'emoji', value: unicode })
        } else if (!isEmoji) {
          currentString += char
        }
      }
      if (currentString !== '') {
        list.push({ type: 'text', value: currentString })
      }
      return list
    },
    toUni (str): string {
      if (str.length < 4) return str.codePointAt(0).toString(16)
      return str.codePointAt(0).toString(16) + '-' + str.codePointAt(2).toString(16)
    },
    isEmoji (unicode): boolean {
      return unicode.startsWith('1f')
    }
  }
})

